import React from "react";
import { Link } from "react-router-dom";

const MasonryLayoutStyle2 = ({ items = [] }) => {
  return (
    <>
      <style>
        {`
          .flat-spacing-28 {
            max-width: 1600px !important;
            margin: 0 auto !important;
            padding-left: 20px !important;
            padding-right: 20px !important;
            box-sizing: border-box !important;
          }

          @media (max-width: 575px) {
            .flat-spacing-28 {
              max-width: 100% !important;
              padding-left: 12px !important;
              padding-right: 12px !important;
            }
          }

          @media (min-width: 576px) and (max-width: 767px) {
            .flat-spacing-28 {
              max-width: 100% !important;
              padding-left: 16px !important;
              padding-right: 16px !important;
            }
          }

          @media (min-width: 768px) and (max-width: 991px) {
            .flat-spacing-28 {
              max-width: 1200px !important;
              padding-left: 20px !important;
              padding-right: 20px !important;
            }
          }

          @media (min-width: 992px) and (max-width: 1199px) {
            .flat-spacing-28 {
              max-width: 1400px !important;
              padding-left: 20px !important;
              padding-right: 20px !important;
            }
          }

          @media (min-width: 1400px) {
            .flat-spacing-28 {
              max-width: 1600px !important;
              padding-left: 20px !important;
              padding-right: 20px !important;
            }
          }
        `}
      </style>
    <section className="flat-spacing-28">
      <div className="container-full">
        <div
          className="masonry-layout style-2 wow fadeInUp"
          data-wow-delay="0s"
        >
          {items.map((item, index) => {
            // Use offer_id if available, otherwise use the provided link
            const itemLink = item.id
              ? `/shop/default?offer_id=${item.id}`
              : item.link || "/shop/collection";

            return (
              <div
                key={index}
                className={`item-${index + 1} collection-item large hover-img`}
              >
                <Link to={itemLink} className="collection-inner">
                  <div className="collection-image img-style rounded-0">
                    <img
                      className="lazyload"
                      data-src={item.image}
                      src={item.image}
                      alt={item.alt || "collection-img"}
                    />
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
    </>
  );
};

export default MasonryLayoutStyle2;
